
import { useDispatch, useSelector } from 'react-redux';
import { 
    getStudentsByAgeGroup, 
    getStudentsByGroup, 
    getAttendances,
    clearStudents,
    clearAttendances 
} from '../store/slices/attendanceSlice';

export const useAttendance = () => {
    const dispatch = useDispatch();
    const { students, attendances, loading, error, selectedFilter } = useSelector((state) => state.attendance);
    const selectedBranch = useSelector((state) => state.branches.selectedBranch);
    const selectedPlace = useSelector((state) => state.branches.selectedPlace);

    // Yaş grubu branş seviyesinde tanımlı, gruptan farklı olarak tek bir şubeye ait değil;
    // şube filtresi verilmezse diğer şubelerin öğrencileri de listeye düşüyor.
    const fetchStudentsByAgeGroup = (ageGroupId, date) => {
        if (selectedBranch?.id && ageGroupId && date) {
            dispatch(getStudentsByAgeGroup({
                ageGroupId,
                date: date.format('YYYY-MM-DD'),
                branchId: selectedBranch.id,
                placeId: selectedPlace?.id
            }));
        }
    };

    const fetchStudentsByGroup = (groupId, date) => {
        if (selectedBranch?.id && groupId && date) {
            dispatch(getStudentsByGroup({
                groupId,
                date: date.format('YYYY-MM-DD'),
                branchId: selectedBranch.id
            }));
        }
    };

    const fetchAttendances = (date, groupId = null, ageGroupId = null) => {
        if (selectedBranch?.id && date) {
            dispatch(getAttendances({
                branchId: selectedBranch.id,
                date: date.format('YYYY-MM-DD'),
                groupId,
                ageGroupId
            }));
        }
    };

    const clearStudentsList = () => {
        dispatch(clearStudents());
    };

    const clearAttendancesList = () => {
        dispatch(clearAttendances());
    };

    return {
        students,
        attendances,
        loading,
        error,
        selectedFilter,
        fetchStudentsByAgeGroup,
        fetchStudentsByGroup,
        fetchAttendances,
        clearStudentsList,
        clearAttendancesList
    };
}; 